import { FunctionalComponent, reactive, Teleport } from 'vue'

import style from  './Toast.module.scss';

class ToastData {
    show: boolean
    msg: string
    display: boolean

    constructor() {
        this.show = false
        this.msg = ''
        this.display = false
    }
}

const toastData = reactive(new ToastData())

class ToastControl {
    async toast(msg: string, timeout = 3000): Promise<void> {
        return new Promise<void>((resolve) => {
            toastData.msg = msg
            toastData.display = true
            toastData.show = true
            const iv = setInterval(() => {
                toastData.display = false
                clearInterval(iv)
                resolve()
            }, timeout)
        })
    }
}

export const Toast: ToastControl = new ToastControl()

// eslint-disable-next-line @typescript-eslint/ban-types
const toast: FunctionalComponent<{}, {}> = function () {
    return toastData.show && (
        <Teleport to="body">
            <div
                onTransitionend={() => {
                    toastData.show = toastData.display
                }}
                class={{
                    [style.ToastWarp]: true,
                    [style.ToastHidden]: !toastData.display
                }}
            >
                {toastData.msg}
            </div>
        </Teleport>
    )
}

toast.props = {}
export default toast
